import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84db72d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-card" }
const _hoisted_2 = { class: "p-3 mt-24 bg-white rounded-2xl border border-neutral-base" }
const _hoisted_3 = { class: "flex justify-between items-center text-center" }
const _hoisted_4 = { class: "text-sm font-semibold text-black" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-light text-black" }, "Número", -1))
const _hoisted_6 = { class: "text-sm font-semibold text-black break-words w-20" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-light text-black" }, "Partido", -1))
const _hoisted_8 = { class: "flex flex-col items-center mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "w-28 h-28 rounded-full shadow-lg mb-3 -mt-24 overflow-hidden"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-base font-semibold text-black overflow-hidden" }
const _hoisted_13 = { class: "text-sm font-light text-black mr-2" }
const _hoisted_14 = { class: "flex justify-between mt-3" }
const _hoisted_15 = {
  key: 0,
  class: "bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded"
}
const _hoisted_16 = {
  key: 1,
  class: "bg-red-100 text-red-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded"
}
const _hoisted_17 = {
  key: 2,
  class: "bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded"
}
const _hoisted_18 = { class: "flex flex-col items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCandidate = _resolveComponent("IconCandidate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.number), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.party), 1),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.image)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _ctx.image,
                alt: "Candidato"
              }, null, 8, _hoisted_10)
            ]))
          : (_openBlock(), _createBlock(_component_IconCandidate, {
              key: 1,
              class: "w-28 h-28 shadow-lg mb-3 -mt-32"
            })),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.name), 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.role), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.status === 'APTO')
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Candidatura apta"))
            : (_ctx.status === 'INAPTO')
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Candidatura inapta"))
              : (_ctx.status === 'CADASTRADO')
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Aguardando julgamento"))
                : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "w-full py-3 px-8 text-sm font-light text-center text-white bg-primary-base rounded-full hover:bg-primary-dark focus:ring-4 focus:outline-none focus:ring-secondary-base",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickCandidate(_ctx.keyCandidate, _ctx.locale, _ctx.roleID)))
        }, " Ver perfil ")
      ])
    ])
  ]))
}